module.exports = __webpack_public_path__ + "img/users_icon.cd12b0b9.svg";